import { API_TIMEOUTS } from "@/shared/config/api-constants";

const READ_METHODS = new Set(["get", "head"]);

/**
 * Таймаут запроса: явный от вызывающего либо дефолт по методу (KAN-595).
 *
 * Раньше дефолт жил в `axios.create({ timeout: 60000 })`, и это делало
 * невозможной любую настройку по месту: axios мержит defaults в конфиг ДО
 * прогонки request-интерсепторов (`Axios.prototype.request`, строка с
 * `mergeConfig(this.defaults, config)`), поэтому проверка «а вдруг вызывающий
 * не задал таймаут» никогда не срабатывала — `config.timeout` уже был 60000.
 * Из-за этого висящий запрос жил минуту: в GlitchTip это ~180 событий
 * `timeout of 60000ms exceeded` со `stage=request_sent_no_response`.
 *
 * Теперь у клиента `timeout: 0` (нет таймаута), а реальное значение
 * проставляет интерсептор через эту функцию.
 */
export function resolveTimeout(method: string | undefined, explicit: number | undefined): number {
  // 0 и undefined одинаково означают «вызывающий ничего не просил»: ноль в
  // axios — это «ждать вечно», и как осознанный выбор он тут не нужен.
  if (typeof explicit === "number" && explicit > 0) return explicit;

  return READ_METHODS.has((method ?? "get").toLowerCase())
    ? API_TIMEOUTS.READ
    : API_TIMEOUTS.WRITE;
}
